const dmiTerms = [
  {
    term: "Active TDS channel",
    definition: "the communication channel that is used for exchanging the application data to perform the DMI function. An established connection and safe communication is preconditioned"
  },
  {
    term: "Application layer",
    definition: "upper layer in the OSI model, interfacing directly to the application"
  },
  {
    term: "Application layer interface",
    definition: "definition of the services offered by the application layer"
  },
  {
    term: "Application process",
    definition: "element within a real open system which performs the information processing for a particular application"
  },
  {
    term: "Big endian",
    definition: "definition where the most significant byte of multi byte data is stored in the lowest address memory location and sent first in the sequence of serialized transmissions"
  },
  {
    term: "Border",
    definition: "rectangle surrounding objects in order to create 3 dimensional impression on the total image display area"
  },
  {
    term: "Bridge",
    definition: "device which stores and forwards frames from one bus to another on the base of their Link Layer addresses"
  },
  {
    term: "Broadcast",
    definition: "nearly simultaneous transmission of the same information to several destinations\n\nNote 1: Broadcast in the TCN is not considered reliable, i.e. some destinations may receive the information and others not."
  },
  {
    term: "Button",
    definition: "object shown to the driver through which a driver action is possible to give input to the ERTMS/ETCS onboard. The object is identified by a label. When using a touch screen technology, the driver action is done via the associated sensitive area on the display area. When using a soft key technology, the driver action is done via the hard key adjacent to the label"
  },
  {
    term: "Caption text",
    definition: "textual attribute of a graphical element"
  },
  {
    term: "Cell",
    definition: "basic unit to define the shape of DMI objects and the proportions of areas. Depending on the resolution of the total image display area, a cell can consist of one or more pixels."
  },
  {
    term: "Closed train",
    definition: "train composed of one or a set of Consists, where the composition does not change during normal operation\n\nEXAMPLE metro, sub-urban train, high speed train units."
  },
  {
    term: "Closed train consist",
    definition: "consist within a closed train"
  },
  {
    term: "Communication channel",
    definition: "Up to four communication channels between the EVC and the TDS are supported by the interface. Each channel has the same configuration of process data ports and message data connections. The communication channel starts and ends at the interface between the communication layer and the SDT protocol for safety-related data as defined in /TCN-TCP/ Annex B.2 or between the communication and the application layer for data not secured by SDT protocol"
  },
  {
    term: "Communication devices",
    definition: "devices connected to Consist Network or Train Backbone with the ability to transport, source or sink data"
  },
  {
    term: "Composition",
    definition: "number, sequence, orientation and characteristics of the consists forming a train"
  },
  {
    term: "Connection",
    definition: "established after version numbers have been successfully exchanged and checked between the EVC and the TDS with safe communication is preconditioned"
  },
  {
    term: "Consist",
    definition: "single vehicle or a group of vehicles which are not separated during normal operation\n\nNote 1: A consist contains no, one or several consist networks."
  },
  {
    term: "Consist network",
    definition: "communication network interconnecting communication devices in one Consist"
  },
  {
    term: "Consist network address",
    definition: "network address, which does not change after inauguration and which is used to address communication device in the own consist network"
  },
  {
    term: "Consist sequence number",
    definition: "sequence number of the Consist in the train as obtained during TCN inauguration"
  },
  {
    term: "Dialogue Sequence",
    definition: "is a mechanism by which the DMI guides the driver through a set of windows in order to fulfil a specific task."
  },
  {
    term: "Disabled",
    definition: "means the related button cannot go to the \"pressed\" state. A disabled button does not respond to any driver actions."
  },
  {
    term: "Discovered vehicle/consist",
    definition: "vehicle/consist discovered during train inauguration"
  },
  {
    term: "Display",
    definition: "combines a screen and input devices and located at the driver desk"
  },
  {
    term: "Display area",
    definition: "zone displaying a piece of visual information and defined by a size (in cells) and a position relative to the positions of the other display areas. It is more commonly named \"area\" in this specification."
  },
  {
    term: "DMI objects",
    definition: "buttons, indicators, text messages, supervision information, planning information and sounds"
  },
  {
    term: "DMI-EVC FFFIS",
    definition: "the Form Fit Function Interface Specification for the interface between the EVC and the TDS. This interface should allow the TDS combined with the EVC to perform the DMI function according to Subset-026, ERA-DMI and Subset-035"
  },
  {
    term: "DMI-EVC Interface Controller",
    definition: "an ETCS component that realises the interface of the ETCS/ATO On-Board and STM with the Train Display System. It can be an additional device to the ETCS On-board or can be integrated into the ETCS On-Board"
  },
  {
    term: "Enabled",
    definition: "means the related button can go to the \"pressed\" state. An enabled button does respond to a driver action."
  },
  {
    term: "End device",
    definition: "unit connected to one Consist Network or to one set of Consist Networks prepared for redundancy reasons"
  },
  {
    term: "ETCS On-board",
    definition: "the ETCS sub-system as specified within CCS TSI and in particular within Subset-026"
  },
  {
    term: "Ethernet Train Backbone",
    definition: "train backbone based on switched Ethernet technology\n\nNote 1: Specified in IEC 61375-2-5."
  },
  {
    term: "Ethernet Train Backbone Node",
    definition: "node connected to the Ethernet train backbone receiving a sequence number during inauguration and capable of forwarding user data packets between Consist Network and Train Backbone"
  },
  {
    term: "Frame",
    definition: "conspicuous rectangle surrounding an object"
  },
  {
    term: "Graphical element",
    definition: "any visual information specified in ERA-DMI"
  },
  {
    term: "Grid array",
    definition: "area grid pattern on the total image display area consisting of cells which results in a visual appearance of information in certain proportions"
  },
  {
    term: "Hard key",
    definition: "physical key not part of the total image display area. This key can also have a text label or symbol"
  },
  {
    term: "Icons",
    definition: "graphical elements that are equivalent to symbols. Term \"Icon\" is used in Subset-035 \"symbol\" is used as in ERA-DMI"
  },
  {
    term: "Indicators",
    definition: "DMI objects that show a system status. They can be a symbol or a label text with an associated background"
  },
  {
    term: "Input device",
    definition: "allows driver inputs to the TDS. It could be e.g. keys integrated into the display box or onto the driver desk"
  },
  {
    term: "Input field",
    definition: "object shown to the driver to echo a data. It is composed of a label part giving the topic of the data and of a data part showing the data itself."
  },
  {
    term: "Label",
    definition: "symbol or text indication on a button or associated to an input field"
  },
  {
    term: "Layer",
    definition: "groups all areas with the same impression of depth using the border technique"
  },
  {
    term: "Leading vehicle",
    definition: "vehicle which controls the movements of the train"
  },
  {
    term: "Linear topology",
    definition: "topology where the nodes are connected in series, with two nodes each connected to only one other node and all others each connected to two other nodes (that is, connected in the shape of a line)"
  },
  {
    term: "Local Area Network",
    definition: "part of a network characterized by a common medium access and address space"
  },
  {
    term: "Medium",
    definition: "physical carrier of the signal: electrical wires, optical fibers, etc."
  },
  {
    term: "Medium access control",
    definition: "sublayer of the Link Layer, which controls the access to the medium (arbitration, mastership transfer, polling)"
  },
  {
    term: "Message",
    definition: "data item transmitted in one or several packets"
  },
  {
    term: "Multicast",
    definition: "transmission of the same message to a group of receivers, identified by their Group Address\n\nNote 1: The word \"multicast\" is used even if the group includes all receivers."
  },
  {
    term: "Multimedia network",
    definition: "network in a train which is used for data transmission of multimedia and telematic data"
  },
  {
    term: "Multimedia services",
    definition: "services which are used for multimedia\n\nNote 1: Onboard multimedia and telematic services are defined in IEC 62580-1."
  },
  {
    term: "Network",
    definition: "set of possibly different communication systems which interchange information in a commonly agreed way"
  },
  {
    term: "Network address",
    definition: "address which identifies a communication device on network layer"
  },
  {
    term: "Network device",
    definition: "components used to set up Consist Networks and Train Networks\n\nNote 1: These may be passive components like cables or connectors, active unmanaged components like repeaters, media converters or (unmanaged) switches, or managed active components like gateways, routers and (managed) switches."
  },
  {
    term: "Network layer",
    definition: "layer in the OSI model responsible for routing between different busses"
  },
  {
    term: "Network management",
    definition: "operations necessary to remotely configure, monitor, diagnose and maintain the network"
  },
  {
    term: "Node",
    definition: "device on the Train Backbone, which may act as a gateway between Train Backbone and Consist Network"
  },
  {
    term: "Onboard multimedia and telematics subsystem",
    definition: "collection of train on-board services and functions for multimedia and telematics\n\nNote 1 to entry: A definition of those services is given in IEC 62580."
  },
  {
    term: "Operational network",
    definition: "network in a train which is used for the transmission of train operation and safety critical data"
  },
  {
    term: "Operational services",
    definition: "all services which are needed to run a train safely"
  },
  {
    term: "Operational train direction",
    definition: "direction of train as seen by driver or train attendance"
  },
  {
    term: "Operational train directory",
    definition: "data structure describing the train composition as seen by driver or train attendance, including information about the leading vehicle and vehicle gaps\n\nNote 1: The operational train directory is a part of the train topology database."
  },
  {
    term: "Operational train view",
    definition: "driver or train attendance view of a train as a sequence of vehicles"
  },
  {
    term: "Operator",
    definition: "enterprise or organization which is operating trains"
  },
  {
    term: "Other On-Board system",
    definition: "equipment using also the Train Display System to perform its DMI. Other On-Board system is not part of ETCS/ATO/STM On-Board. It could be e.g. train control and management system, voice radio, maintenance system, time table..."
  },
  {
    term: "PD publisher",
    definition: "device which cyclically sends PD telegrams with a defined ComId to a defined address or address range"
  },
  {
    term: "PD requester",
    definition: "device which requests a single PD telegram of a specified ComId to be sent to a specified address or address range"
  },
  {
    term: "PD subscriber",
    definition: "device which receives PD telegrams with a defined ComId and a possible source address filter"
  },
  {
    term: "Planning information",
    definition: "the relevant trackside information in front of the train which is displayed to the driver as defined in ERA-DMI"
  },
  {
    term: "Pressed",
    definition: "means a driver action on the button is ongoing."
  },
  {
    term: "Producer",
    definition: "sender of a message at the Transport Layer"
  },
  {
    term: "Publisher",
    definition: "source of a dataset for broadcasting (see subscriber)"
  },
  {
    term: "Regular transmission",
    definition: "data transmission of non safety related data"
  },
  {
    term: "Repeater",
    definition: "connection at the Physical Layer between bus segments, providing an extension of the bus beyond the limits permitted by passive means\n\nNote 1: The connected segments operate at the same speed and with the same protocol. The delay introduced by a repeater is in the order of one bit duration."
  },
  {
    term: "Residual error rate",
    definition: "probability of integrity breach (unrecognized wrong bit) per transmitted bit"
  },
  {
    term: "Ring topology",
    definition: "active network where each node is connected in series to two other nodes\n\nNote 1: Ring may also be referred to as loop."
  },
  {
    term: "Router",
    definition: "connection between two busses at the Network Layer, which forwards telegrams from one bus to another on the base of their network address"
  },
  {
    term: "Safe communication",
    definition: "ensured while no error is indicated from SDT protocol execution. The SDT protocol is applied for safety-related process and message data"
  },
  {
    term: "Safe data transmission",
    definition: "data transmission of safety related data"
  },
  {
    term: "Safe Message Data (MD) Connection",
    definition: "established when the enhanced SDT protocol assures safe message data transmission"
  },
  {
    term: "Sensitive area",
    definition: "area on which a driver can make a physical action to give input to the ERTMS/ETCS onboard"
  },
  {
    term: "Soft key",
    definition: "context-dependent key which consists of a hard key with an associated label on the total image display area"
  },
  {
    term: "Sound generator",
    definition: "the device that plays ETCS/ATO/STM sounds"
  },
  {
    term: "Sporadic data",
    definition: "transmission of data on a demand basis"
  },
  {
    term: "Subscriber",
    definition: "one of the sinks of a broadcast dataset (see publisher)"
  },
  {
    term: "Supervision information",
    definition: "the DMI representation of:\n- the train speed,\n- target speed and distance,\n- permitted speed,\n- release speed,\n- intervention speed,\n- normal, indication, warning, over speed, intervention status,\n- indication location,\n- ceiling speed monitoring (CSM),\n- target speed monitoring (TSM),\n- release speed monitoring (RSM),\n- lowest supervised speed within the movement authority (LSSMA)"
  },
  {
    term: "Symbol",
    definition: "presentation of information in graphical form instead of using text"
  },
  {
    term: "Topography counter",
    definition: "unique identifier of a train composition"
  },
  {
    term: "Topology",
    definition: "possible cable interconnection and number of devices in a given network"
  },
  {
    term: "Total image display area",
    definition: "Image formed by the contribution of all individual display areas"
  },
  {
    term: "Touch screen",
    definition: "Using the display area for driver's inputs by means of programmable sensitive areas"
  },
  {
    term: "Train",
    definition: "composition of one or a set of Consists, where the configuration can change during normal operation"
  },
  {
    term: "Train backbone",
    definition: "bus connecting the consists of a train\n\nNote 1: Conforms to IEC 61375-2-1 (WTB) or IEC 61375-2-5 (ETB)."
  },
  {
    term: "Train backbone node",
    definition: "device on the train backbone which receives a train backbone node number during inauguration.\n\nNote 1: A train backbone node can be used to connect an End Device or a Consist Network to the Train Backbone."
  },
  {
    term: "Train backbone view",
    definition: "train seen as a sequence of consist networks determined by ETB inauguration"
  },
  {
    term: "Train communication network",
    definition: "data communication network for connecting programmable electronic equipment on-board rail vehicles"
  },
  {
    term: "Train communication system",
    definition: "train communication network plus its communication and application profile for the exchange of information trainwide"
  },
  {
    term: "Train directory",
    definition: "data structure describing the train composition after a train inauguration\n\nNote 1: The train directory is a part of the train topology database."
  },
  {
    term: "Train directory computation",
    definition: "protocol to determine the actual train composition as a set of consists containing vehicles containing function devices\n\nNote 1: Optional closed trains represented as consists can be detected and interpreted as a set of consists. Result of the train directory computation is the train directory data structure which is a part of the train topology database."
  },
  {
    term: "Train display controller",
    definition: "controls at least one display, the associated input devices and the sound generator. The train display controller implements the TDS part of the DMI function and provides the interface to the DMI-EVC Interface Controller"
  },
  {
    term: "Train Display System (TDS)",
    definition: "the train cab display system that comprises and manages one or more displays on the driver desk and a driver interface as defined in ERA-DMI. It is composed of at least one display with the associated input devices, at least one sound generator and at least one Train Display Controller. For two-cab trains, the Train Display System comprises both cab display functions"
  },
  {
    term: "Train network address",
    definition: "dynamic network address, which is used to address communication devices in other consist networks.\n\nNote 1: This address can change after each inauguration."
  },
  {
    term: "Train network management",
    definition: "services of the network management for TCN"
  },
  {
    term: "Train reference direction",
    definition: "direction determined by inauguration"
  },
  {
    term: "Train topology database",
    definition: "data base collecting all the information about the actual train composition\n\nNote 1: An instance of this database is computed within each consist of the train."
  },
  {
    term: "Train view",
    definition: "train seen as sequence of consists determined by the ETB inauguration"
  },
  {
    term: "Transport layer",
    definition: "layer of the OSI model responsible for end-to-end flow control and error recovery"
  },
  {
    term: "UIC vehicle identification number",
    definition: "12-digit number for the unique identification of vehicles\n\nNote 1: As defined by the UIC."
  },
  {
    term: "Unspecified PDU",
    definition: "TRDP PDU with comId=0\n\nNote 1: The user data content of an unspecified PDU is undetermined for the communication profile. Different PDUs and their content can be distinguished only at application level."
  },
  {
    term: "Vehicle",
    definition: "single coach or locomotive"
  },
  {
    term: "Vehicle gap",
    definition: "vehicle listed in the confirmed vehicle list of the operational train directory which is not reachable over ETB\n\nNote 1: A vehicle gap can be at one train end or in the middle of a train. There may also exist more than one vehicle gap in a train.\n\nNote 2: Vehicle gaps may be determined by the driver while comparing the indicated unconfirmed train composition with the real train composition, leading to a correction of the train composition."
  },
  {
    term: "Visual information",
    definition: "displayed on a DMI screen (e.g. speed gauge)"
  },
  {
    term: "Visual information data",
    definition: "the data used to display visual information (e.g. speed value)"
  },
  {
    term: "Window",
    definition: "a presentation of objects, text messages, input fields and/or buttons related to a single topic."
  }
]

export default function DmiTerms() {
  const stickyHeaderStyle = {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "var(--bs-table-bg, #f8f9fa)"
  };

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-3 flex-wrap">
        <div>
          <h3 className="mb-1">Terms</h3>
          <div className="text-muted">
            Terms and definitions used in the referenced specifications.
          </div>
        </div>

        <span className="badge text-bg-secondary">
          Total: {dmiTerms.length}
        </span>
      </div>

      <div style={{ maxHeight: "65vh", overflowY: "auto" }}>
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th style={{ ...stickyHeaderStyle, width: "240px" }}>Term</th>
              <th style={stickyHeaderStyle}>Definition</th>
            </tr>
          </thead>

          <tbody>
            {dmiTerms.map((item, index) => (
              <tr key={item.term} style={getRowStyle(index)}>
                <td className="fw-semibold">{item.term}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.definition}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
